module.exports = __webpack_public_path__ + "static/ma-6-3b63ab4d4ed1e16768e2a754d5883812.png";